import { Frame } from '@dentsu-ui/components';

// Shell for Frame - used in app.js
export function Shell({ children, navigation }) {
  return <Frame navigation={navigation}>{children}</Frame>;
}
